export const environment = {
    production: false,
    EnvironmentURL: 'assets/environment.json',
    StatusURL: 'assets/status.json',
};